jQuery(function ($) {
  const pageProduct = window.product || null;
  const $wishlistButton = $('[data-wishlist-button]');
  const productId = Number($wishlistButton.data('product-id') || (pageProduct && pageProduct.id));
  const productVariants = (pageProduct && pageProduct.variants) || [];

  const isLoggedIn = Boolean(window.__BFLAT__?.isLoggedIn);

  if (!$wishlistButton.length || !productId) return;

  // -----------------------------
  // Guest localStorage settings
  // -----------------------------
  const storage = !isLoggedIn ? window.localStorage : null;
  const GUEST_KEY = 'wishlist:variants:v1';
  const GUEST_MAX = 30;

  const state = {
    favorites: new Set(), // variant_id Set<number>
    activeVariantId: null,
    loading: false,
  };

  const labelEl =
    $wishlistButton.find('.favorite-button__label')[0] ||
    $wishlistButton.find('.wishlist-button__label')[0];

  const setLoading = isLoading => {
    state.loading = isLoading;
    $wishlistButton.toggleClass('is-loading', isLoading);
    $wishlistButton.prop('disabled', isLoading);
  };

  const getCurrentVariantId = () => {
    const selectVal = $('select.variant-selector').val();
    return selectVal ? Number(selectVal) : null;
  };

  const updateButton = () => {
    const variantId = state.activeVariantId || getCurrentVariantId();
    const isSaved = variantId ? state.favorites.has(Number(variantId)) : false;
    $wishlistButton.toggleClass('is-active', isSaved);
    if (labelEl) {
      labelEl.textContent = isSaved ? 'お気に入りに追加済み' : 'お気に入りに追加';
    }
  };

  const setActiveVariant = variantId => {
    if (!variantId) return;
    state.activeVariantId = Number(variantId);
    updateButton();
  };

  // ---------------------------------
  // Guest localStorage helpers (v1)
  // ---------------------------------
  const nowMs = () => Date.now();

  const loadGuestItems = () => {
    if (!storage) return [];
    try {
      const raw = storage.getItem(GUEST_KEY);
      const arr = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(arr)) return [];
      return arr
        .map(x => ({ id: Number(x?.id), at: Number(x?.at) }))
        .filter(x => Number.isFinite(x.id) && x.id > 0 && Number.isFinite(x.at) && x.at > 0);
    } catch (e) {
      console.warn('wishlist guest parse error', e);
      return [];
    }
  };

  const saveGuestItems = items => {
    if (!storage) return;
    const normalized = items
      .slice()
      .sort((a, b) => b.at - a.at)
      .slice(0, GUEST_MAX);

    try {
      storage.setItem(GUEST_KEY, JSON.stringify(normalized));
    } catch (e) {
      console.warn('wishlist guest save error', e);
    }
  };

  const guestItemsToSet = items =>
    new Set(items.map(x => Number(x.id)).filter(Boolean));

  const guestAddVariant = variantId => {
    const id = Number(variantId);
    if (!storage || !id) return { ok: false };

    const items = loadGuestItems();
    const idx = items.findIndex(x => x.id === id);

    if (idx >= 0) {
      // 既存：日時更新（新しい順にするため）
      items[idx].at = nowMs();
      saveGuestItems(items);
      return { ok: true, items };
    }

    if (items.length >= GUEST_MAX) {
      alert(`未ログインの場合、お気に入りは最大${GUEST_MAX}件まで保存できます。会員登録（無料）すると、さらに多くの商品を保存できます。`);
      return { ok: false, reason: 'LIMIT' };
    }

    items.push({ id, at: nowMs() });
    saveGuestItems(items);
    return { ok: true, items };
  };

  const guestRemoveVariant = variantId => {
    const id = Number(variantId);
    if (!storage || !id) return { ok: false };
    const items = loadGuestItems().filter(x => x.id !== id);
    saveGuestItems(items);
    return { ok: true, items };
  };

  // -----------------------------
  // API helpers (logged-in)
  // -----------------------------
  const fetchFavorites = async () => {
    // Guest: load from global key only (no API)
    if (!isLoggedIn) {
      const guestItems = loadGuestItems();
      state.favorites = guestItemsToSet(guestItems);
      updateButton();
      return;
    }

    // Logged-in: fetch from API (product scoped)
    try {
      const res = await fetch(`/apps/bflat/wishlists/products/${productId}/variants`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
      });

      if (!res.ok) throw new Error(`Fetch favorites failed: ${res.status}`);

      const json = await res.json().catch(() => null);
      const ids = json.wished_variant_ids.map(Number).filter(Boolean);

      state.favorites = new Set(ids);
      updateButton();
    } catch (e) {
      console.error(e);
    }
  };

  const addFavorite = async variantId => {
    if (!isLoggedIn) {
      const r = guestAddVariant(variantId);
      if (!r.ok) return; // LIMIT等は追加しない
      state.favorites.add(Number(variantId));
      return;
    }

    const res = await fetch('/apps/bflat/wishlists/variants', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        product_id: productId,
        variant_id: variantId,
      }),
    });

    if (!res.ok) throw new Error(`Add favorite failed: ${res.status}`);
    state.favorites.add(Number(variantId));
  };

  const removeFavorite = async variantId => {
    if (!isLoggedIn) {
      guestRemoveVariant(variantId);
      state.favorites.delete(Number(variantId));
      return;
    }

    const res = await fetch(`/apps/bflat/wishlists/variants/${variantId}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
    });

    if (!res.ok) throw new Error(`Remove favorite failed: ${res.status}`);
    state.favorites.delete(Number(variantId));
  };

  const handleToggle = async () => {
    const variantId = state.activeVariantId || getCurrentVariantId();
    if (!variantId || state.loading) return;

    const isSaved = state.favorites.has(Number(variantId));

    setLoading(true);
    try {
      if (isSaved) {
        await removeFavorite(variantId);
      } else {
        await addFavorite(variantId);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
      updateButton();
    }
  };

  // -----------------------------
  // Event bindings
  // -----------------------------
  $wishlistButton.on('click', handleToggle);

  $(window).on('cc-variant-updated', (event, payload) => {
    const vid = payload && payload.variant && payload.variant.id;
    if (vid) setActiveVariant(vid);
  });

  $(document).on('change', 'select.variant-selector', function () {
    const vid = Number($(this).val());
    if (vid) setActiveVariant(vid);
  });

  // -----------------------------
  // Initialize
  // -----------------------------
  const initialVariant =
    getCurrentVariantId() ||
    (pageProduct && pageProduct.selected_or_first_available_variant && pageProduct.selected_or_first_available_variant.id) ||
    (productVariants[0] && productVariants[0].id);

  setActiveVariant(initialVariant);
  fetchFavorites();
});
